import { render } from "./ChatRoomOne.vue?vue&type=template&id=d887e3bc&scoped=true"
import script from "./ChatRoomOne.vue?vue&type=script&lang=js"
export * from "./ChatRoomOne.vue?vue&type=script&lang=js"

import "./ChatRoomOne.vue?vue&type=style&index=0&id=d887e3bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d887e3bc"]])

export default __exports__